import moment from 'moment';

import { APP_LOCAL_DATETIME_FORMAT, APP_LOCAL_DATETIME_FORMAT_Z } from 'app/shared/config/constants';

export const convertDateTimeFromServer = date => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = date => (date ? moment(date, APP_LOCAL_DATETIME_FORMAT_Z).toDate() : null);

export const displayDefaultDateTime = () =>
  moment()
    .startOf('day')
    .format(APP_LOCAL_DATETIME_FORMAT);

export const formatDate = (date: Date) => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

export const dateFormat = (dateString?: string) => {
  let dateOb;
  let year;
  if (dateString) {
    dateOb = new Date(dateString);
    year = dateOb.getFullYear();
  } else {
    dateOb = new Date();
    year = dateOb.getFullYear() - 18;
  }
  const date = ('0' + dateOb.getDate()).slice(-2);
  const month = ('0' + (dateOb.getMonth() + 1)).slice(-2);
  return year + '-' + month + '-' + date;
};

export const getDateYearsAgo = (years: number) => (dateInMs: number) => {
  const date = new Date(dateInMs);
  return new Date(date.getFullYear() - years, date.getMonth(), date.getDate());
};

export const getYYYMMDDDateFormat = (date: Date) => {
  return date.toISOString().split('T')[0];
};

export const formatBirthdayForInput = date => {
  if (!date) return '';
  const d = new Date(date);
  return d.toISOString().split('T')[0]; // convertit la date au format YYYY-MM-DD
};
